import enviro from 'enviro';
import { DELIVERY_METHOD_NAMES, DELIVERY_METHOD_NAME_MAP } from '../../constants';
import { browserNotificationInteractionCreator } from '../../utils/analytics/NotificationsUsageTrackers';
import { canShowBrowserNotifications } from './canShowBrowserNotifications';
import { createNotificationArgs } from './createNotificationArgs';
import { handleSalesNotification } from './SalesExtension/handleSalesNotification';
import { markAsDelivered } from '../../api/notificationsApi';
export const handleWebsocketNotification = (browserNotification, isPrimary) => {
  const {
    deliveryMethods,
    ctaProxyUrl
  } = browserNotification;
  const canHandleAsBrowserNotification = isPrimary && deliveryMethods.includes(DELIVERY_METHOD_NAME_MAP.BROWSER);
  if (canHandleAsBrowserNotification) {
    void markAsDelivered({
      deliveryMethod: DELIVERY_METHOD_NAMES.BROWSER,
      notificationId: browserNotification.id
    });
  }
  if (!canHandleAsBrowserNotification || !canShowBrowserNotifications()) {
    return;
  }
  handleSalesNotification(browserNotification, enviro.isQa());
  const shouldIgnoreBasedOnVisibility = deliveryMethods.length === 1 ? false // This would only ever be expected to show via browser notification, don't ignore it
  : document.visibilityState === 'visible'; // HubSpot app is showing, can skip a browser notification

  if (shouldIgnoreBasedOnVisibility) {
    return;
  }
  const args = createNotificationArgs(browserNotification, false);
  const notification = new Notification(...args);
  notification.addEventListener('click', () => {
    browserNotificationInteractionCreator(browserNotification, 'native-browser-notification-click');
    window.parent.focus();

    // eslint-disable-next-line no-restricted-syntax
    window.open(ctaProxyUrl, '_blank');
  });
};